import { FunctionComponent, memo } from 'react';
import { useTranslation } from 'react-i18next';

import classes from './CardOpenButton.module.scss';

interface CardOpenButtonProps {
  label?: string;
  ariaExpanded?: boolean;
  onClick?: () => void;
}

export const CardOpenButton: FunctionComponent<CardOpenButtonProps> = memo(
  ({ label, ariaExpanded, onClick }) => {
    const { t } = useTranslation();

    return (
      <button
        type={'button'}
        className={classes['card-open-button']}
        aria-label={label?.trim() || t('common.open')}
        aria-expanded={ariaExpanded}
        onClick={onClick}
      />
    );
  }
);
